import { getCurrentLanguage } from '../../language/selectors/language';

export const getRouteToRedirect = state => {
  const language = getCurrentLanguage();
  const { location: { pathname, search } } = state.router;
  const url = pathname + search;

  return url.replace(`/${ language }`, '');
};

export const getOrganizationFromRouter = state => {
  const { location: { search } } = state.router;
  const params = new URLSearchParams(search);

  return params.get('orgId');
};

export const getExternalUserIdFromRouter = state => {
  const { location: { search } } = state.router;
  const params = new URLSearchParams(search);

  return params.get('euId');
};
